var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHeart = function SvgHeart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    viewBox: "0 0 20 18"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    stroke: "#000",
    d: "M13.974 1a4.871 4.871 0 00-4.055 2.162A4.871 4.871 0 001 5.829c0 5.633 6.486 8.65 8.919 10.663 2.433-2.013 8.919-5.03 8.919-10.663A4.848 4.848 0 0013.974 1z",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeWidth: 2
  }))));
};
export default SvgHeart;